import { render, staticRenderFns } from "./OrderList.vue?vue&type=template&id=2f27986c&"
import script from "./OrderList.vue?vue&type=script&lang=js&"
export * from "./OrderList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/data/jenkins/workspace/booking-fe-stg/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f27986c')) {
      api.createRecord('2f27986c', component.options)
    } else {
      api.reload('2f27986c', component.options)
    }
    module.hot.accept("./OrderList.vue?vue&type=template&id=2f27986c&", function () {
      api.rerender('2f27986c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/App/VPL/MyOrder/OrderList.vue"
export default component.exports